import { useState } from "react";
import { PRESETS, getPresetRange } from "../../utils/dateRanges";
import { isoDay } from "../../utils/format";

export default function TimeRangePicker({ value, onChange }) {
  const [customStart, setCustomStart] = useState(isoDay(value.start));
  const [customEnd, setCustomEnd] = useState(isoDay(value.end));

  function handlePreset(key) {
    if (key === "custom") {
      onChange({ preset: "custom", start: new Date(customStart), end: new Date(customEnd) });
      return;
    }
    onChange({ preset: key, ...getPresetRange(key) });
  }

  function applyCustomRange() {
    onChange({ preset: "custom", start: new Date(customStart), end: new Date(customEnd) });
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            onClick={() => handlePreset(p.key)}
            className={`px-4 py-2 font-mono text-xs uppercase tracking-widest border border-solid border-collectors-black transition-colors ${
              value.preset === p.key
                ? "bg-collectors-black text-white"
                : "bg-transparent text-collectors-black hover:bg-collectors-black hover:text-white"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      {value.preset === "custom" && (
        <div className="flex flex-wrap items-end gap-4">
          <div className="flex flex-col gap-1">
            <label className="font-mono text-xs uppercase tracking-widest text-collectors-gray">
              Start
            </label>
            <input
              type="date"
              value={customStart}
              onChange={(e) => setCustomStart(e.target.value)}
              className="bg-transparent border-solid border-b-2 border-collectors-light py-1 font-mono
                      text-sm text-collectors-black focus:outline-none focus:border-collectors-black"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="font-mono text-xs uppercase tracking-widest text-collectors-gray">
              End
            </label>
            <input
              type="date"
              value={customEnd}
              onChange={(e) => setCustomEnd(e.target.value)}
              className="bg-transparent border-solid border-b-2 border-collectors-light py-1 font-mono
                      text-sm text-collectors-black focus:outline-none focus:border-collectors-black"
            />
          </div>
          <button
            onClick={applyCustomRange}
            className="px-4 py-2 font-mono text-xs uppercase tracking-widest border border-solid
                    border-collectors-black hover:bg-collectors-black hover:text-white transition-colors"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
}